import classes from './DateButton.module.scss'
import { FaCalendarAlt } from 'react-icons/fa'
import { forwardRef } from 'react'

export interface Props {
  onClick: () => void
  value: string
}

const DATE_STRING_OPTIONS = {
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
  hour12: true
} as Intl.DateTimeFormatOptions

const DateButton = forwardRef((
  {
    onClick,
    value
  }: Props,
  ref: any
) =>
  <button
    className={classes.DateButton}
    onClick={onClick}
    ref={ref}
    title=''
    type='button'
  >
    <time
      dateTime={value}
    >
      {new Date(value).toLocaleDateString(undefined, DATE_STRING_OPTIONS).replace(',', ' -')}
    </time>
    <FaCalendarAlt
      aria-hidden
      size='1.25em'
    />
  </button>
)

export default DateButton
